import CalculateButton from '../../common/calculateButton';
import SaveButton from '../../common/saveButton';

const ButtonContainer = ({
  URL,
  calculate,
  checkCalculationNameforSaving,
  calculationInput,
  layersFrontLength,
  isLoadingCalculate,
  isLoadingLoad,
  isLoadingSave,
  saveButtonDisabled,
  calculateButtonDisabled,
  calculationCountReached,
  saveCountReached,
  children,
}) => {
  return (
    <div className="buttonContainer SPTbuttonContainer Vs30SiteClassEc8CalcSaveButtonContainer">
      <CalculateButton
        calculationCountReached={calculationCountReached}
        calculate={calculate}
        calculationInput={calculationInput}
        URL={URL}
        calculateButtonDisabled={calculateButtonDisabled}
        isLoadingCalculate={isLoadingCalculate}
        isLoadingLoad={isLoadingLoad}
        isLoadingSave={isLoadingSave}
        layersFrontLength={layersFrontLength}
      />

      {children}

      <SaveButton
        saveCountReached={saveCountReached}
        checkCalculationNameforSaving={checkCalculationNameforSaving}
        calculationInput={calculationInput}
        URL={URL}
        saveButtonDisabled={saveButtonDisabled}
        isLoadingCalculate={isLoadingCalculate}
        isLoadingLoad={isLoadingLoad}
        isLoadingSave={isLoadingSave}
        layersFrontLength={layersFrontLength}
      />
    </div>
  );
};
export default ButtonContainer;
